module.exports = __webpack_public_path__ + "static/media/agent.eb64b359.svg";